<template>
    <div class="channelNav">
      <div class="nav-main">
        <ul>
          <li><a :href="webUrl+'/'"  @click="goColumn">网站首页</a></li>
          <li v-for="(item,index) in navList.slice(0,14)" >
            <a :href="webUrl+'\/'+item.codeEn+'?id='+item._id+'.html&title='+item.title" @click="goColumn" :data-title="item.title" class="a-block">
              {{item.title}}
            </a>
          </li>
        </ul>
        <div class="app-ewm">
          <img src="@/assets/img/app-download.png" alt="app">
          <div class="download-ewm">
            <div class="ewm-item">
              <div><img src="@/assets/img/rmyd-app-android.png" alt=""></div>
              <div>人民优点APP-android</div>
            </div>
            <div class="ewm-item">
              <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/android-app-download.png" alt=""></div>
              <div>人民众点APP-android</div>
            </div>
            <div class="ewm-item">
              <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/ios-app-download.jpeg" alt=""></div>
              <div>人民众点APP-ios</div>
            </div>
            <div class="ewm-item">
              <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/tou-tiao-ewm.jpeg" alt=""></div>
              <div>人民众网头条号</div>
            </div>
            <div class="ewm-item" style="border-right: 0;">
              <div><img src="https://yjy.goodwebuy.cn/rmzd/assets/img/gong-zhong-ewm.jpeg" alt=""></div>
              <div>人民互联网电视公众号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import {newsNav,webUrl} from "@/api";

  export default {
    name: "PicTop",
    data() {
      return {
        webUrl,
        title:'',
        navList: [],
      }
    },
    created() {
      let route_title=this.$route.query.title;
      this.title=route_title?route_title:localStorage.getItem("title");

      newsNav().then(res => {
        if (!res.code) {
          this.navList = res.list;
        }
      });

    },
    mounted(){},
    watch: {
      $route() {
        // this.columnId = this.$route.meta.queryId || this.$route.query.id.split('.')[0] || this.$route.query.id;
      }
    },
    methods: {
      goColumn(e){
        let title=e.currentTarget.dataset.title;
        localStorage.setItem("title",!title?"":title)
        // this.title=e.currentTarget.dataset.title
        // this.eventHub.$emit('on:title', !title?"":title)
      }

    },
    metaInfo(){
      return {
        title:this.$route.meta.title+'-人民互联网电视'
      }
    }
  }
</script>

<style scoped>
  .channelNav{
    width: 100%;
    height: 50px;
    background: #F3F3F3;
  }
  .channelNav .nav-main{
    width: 1120px;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
    /* padding: 0 30px; */
    margin: 0 auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
  }
  .channelNav .nav-main ul{
    width: 874px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
  }
  .channelNav .nav-main ul li a{
    font-size: 14px;
    color: #232323 !important;
  }
  .channelNav .nav-main ul .logo-channel img{
    width: 34px;
    height: 28px;
    margin-top: 11px;
  }
  .channelNav .nav-main .search{
    width: 161px;
    height: 100%;
    position: relative;
  }
  .channelNav .nav-main .search input{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #FFFFFF;
    background: #E9696D;
    border-radius: 15px;
    box-sizing: border-box;
    padding-left: 42px;
    border: none;
  }
  .channelNav .nav-main .search input::-webkit-input-placeholder{
    font-size: 12px;
    color: #FFFFFF;
  }
  .channelNav .nav-main .search input::-moz-placeholder{
    font-size: 12px;
    color: #FFFFFF;
  }
  .channelNav .nav-main .search input::-ms-input-placeholder{
    font-size: 12px;
    color: #FFFFFF;
  }
  .channelNav .nav-main .search img.search-channel{
    width: 14px;
    height: 14px;
    position: absolute;
    left: 20px;
    top: 18px;
    cursor: pointer;
  }
  .channelNav .nav-main .app-ewm{
    display: block;
    width: 18px;
    height: 21px;
  }
  .channelNav .nav-main .app-ewm img{
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .channelNav .nav-main .app-ewm:hover .download-ewm{
    display: block;
    display: flex;
  }
  .channelNav .nav-main .app-ewm .download-ewm{
    width:880px;
    height:170px;
    background-color: #FFFFFF;
    box-shadow:0px 6px 18px 0px rgba(0, 0, 0, 0.18);
    color: #000000;
    position: relative;
    top: 0;
    left: -850px;
    z-index: 10;
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    -webkit-justify-content: space-around;
    align-items: center;
    display: none;
  }
  .channelNav .nav-main .app-ewm .download-ewm .ewm-item{
    flex: 1;
    -webkit-flex: 1;
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #E6E6E6;
  }
  .channelNav .nav-main .app-ewm .download-ewm .ewm-item img{
    width:85px;
    height:85px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/PicTop.vue